const CUSTOM_LOGO_LOCAL_STORAGE_KEY = "custom-timelog.eu-logo";
export default defineNuxtPlugin(() => {
  const onUpdateCallbacks = ref<((imgStr: string | undefined) => void)[]>([]);
  return {
    provide: {
      customLogo: {
        getLogoDataUrl() {
          if (import.meta.client) {
            const result = localStorage.getItem(CUSTOM_LOGO_LOCAL_STORAGE_KEY);
            return result;
          } else {
            return undefined;
          }
        },

        callCallbacks(imgStr: string | undefined) {
          for (const cb of onUpdateCallbacks.value) {
            cb(imgStr);
          }
        },

        setLogo(logo: File) {
          // TODO: do much more validation!
          if (import.meta.client) {
            const reader = new FileReader();
            reader.addEventListener("load", (event) => {
              const result = event.target?.result as string;
              localStorage.setItem(CUSTOM_LOGO_LOCAL_STORAGE_KEY, result);
              this.callCallbacks(result);
            });
            reader.readAsDataURL(logo);
          }
        },
        onUpdate(cb: (imgStr: string | undefined) => void) {
          onUpdateCallbacks.value.push(cb);
        },
        reset() {
          localStorage.removeItem(CUSTOM_LOGO_LOCAL_STORAGE_KEY);
          this.callCallbacks(undefined);
        },
      },
    },
  };
});
